import { Menu } from '@mui/icons-material';
import { Box, Divider, MenuItem, Tooltip } from '@mui/material';
import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useLocation, useNavigate } from 'react-router-dom';

import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { useTranslation } from 'react-i18next';
import { ROLE_LEVEL } from 'src/constants/role';
import { useAppSelector } from 'src/redux_store';
import { MENU_LIST } from 'src/routes/menu';
import { EPermissions } from 'src/types/enum';
import { IMenuRoute } from 'src/types/route';
import { ButtonMobile, ButtonTop, MenuMobile, useStyles } from './styles';

interface IProps {
  toggleSidebar: () => void;
}

const SidebarSmall = ({ toggleSidebar }: IProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const { role, customer, customerId } = useAppSelector((state) => state.myAccountSlice);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const [open, setOpen] = React.useState<{
    [x: string]: boolean;
  }>({});

  const pathArr = location.pathname.split('/');

  const handleOpen = (event: React.MouseEvent<HTMLElement>, name: string) => {
    setAnchorEl(event.currentTarget);
    setOpen({ [name]: true });
  };
  const handleClose = (name: string) => {
    setAnchorEl(null);
    setOpen({ [name]: false });
  };

  const renderIcon = (menu: IMenuRoute) => {
    let Icon;

    if (pathArr.includes(menu.key)) {
      Icon = menu.activeIcon;
    } else {
      Icon = menu.icon;
    }

    return <Icon color={pathArr.includes(menu.key) ? 'primary' : 'default'} />;
  };

  const handleClickCustomerUser = () => {
    const from = `/customers/${customerId}/manage`;

    if (!(role?.permissions || []).includes(EPermissions.UPDATE_CUSTOMER)) {
      return navigate(`${from}/stations`, { replace: true });
    }

    if (!customerId || !customer) return;

    return navigate(from);
  };

  const renderMenuList = () => {
    return MENU_LIST.map((menu, index) => {
      if (!menu.isHaveMenu) return;

      const permissions = role.permissions || [];
      const isShow = _.isEmpty(_.intersection(menu.permission, permissions));

      if ((role.level !== ROLE_LEVEL.SUPER_ADMIN && isShow && menu.permission) || !menu.isHaveMenu)
        return;

      const from = `/customers/${customerId}/${menu.key}`;

      return (
        <React.Fragment key={index}>
          <Box className={classes.listItem} onClick={(e) => handleOpen(e, menu.id)}>
            <Tooltip title={t(menu.id)} arrow placement="right">
              <ButtonMobile
                onClick={() => menu?.path && navigate(from, { state: menu.key })}
                className={classNames({
                  active:
                    pathArr.includes(menu.key) ||
                    !_.isEmpty(menu?.subMenu?.find((item) => location.pathname === item.path)),
                })}
              >
                {renderIcon(menu)}
              </ButtonMobile>
            </Tooltip>
          </Box>
          {menu?.subMenu && (
            <MenuMobile
              id={menu.path}
              open={Boolean(open?.[menu.id])}
              anchorEl={anchorEl}
              elevation={2}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              onClose={() => menu?.path && handleClose(menu.path)}
            >
              {menu.subMenu?.map((item, index) => (
                <MenuItem
                  className={classNames({
                    active_menu: item.path === location.pathname,
                  })}
                  onClick={() => {
                    handleClose(menu.id);
                    navigate(item.path);
                  }}
                  key={index}
                >
                  {t(item.id)}
                </MenuItem>
              ))}
            </MenuMobile>
          )}
        </React.Fragment>
      );
    });
  };

  return (
    <Box className={classes.root}>
      <Box>
        <Tooltip title={t('button.expand.sidebar')} arrow placement="right">
          <ButtonTop onClick={toggleSidebar} className={classes.topButton}>
            <Menu />
          </ButtonTop>
        </Tooltip>
      </Box>
      <Divider />
      <Box className={classes.top}>
        <Scrollbars>
          <Box>
            {renderMenuList()}

            {(role?.permissions || []).includes(EPermissions.UPDATE_CUSTOMER) && (
              <Box className={classes.listItem} onClick={(e) => handleOpen(e, 'routes.customers')}>
                <Tooltip title={t('routes.customerManagement')} arrow placement="right">
                  <ButtonMobile
                    onClick={handleClickCustomerUser}
                    className={classNames({
                      active: pathArr.includes('manage'),
                    })}
                  >
                    {pathArr.includes('manage') ? (
                      <ManageAccountsIcon />
                    ) : (
                      <ManageAccountsOutlinedIcon />
                    )}
                  </ButtonMobile>
                </Tooltip>
              </Box>
            )}
          </Box>
        </Scrollbars>
      </Box>

      {/* <Box>
        <Box className={classes.bottomButton}>
          <Tooltip title={t('routes.systemManagement')} arrow placement="right">
            <ButtonMobile
              className={classNames({
                active: location.pathname === PATH.systemManagement,
              })}
              onClick={() => navigate(PATH.systemManagement)}
            >
              {location.pathname === PATH.systemManagement ? <Settings /> : <SettingsOutlined />}
            </ButtonMobile>
          </Tooltip>
        </Box>
      </Box> */}
    </Box>
  );
};

export default SidebarSmall;
